import React, { useContext } from "react";
import { ThemeContext } from "../../context/ThemeProvider";
import HTMLContent from "../HTMLContent";
import { getThemeBlackWhiteColor, getStudyIconBg, getPracticeTestIconBg } from "../../utils/themeUtils";
import { motion } from "framer-motion";

const QuestionOptions = (props) => {
  const { theme, getThemeName, currentTheme } = useContext(ThemeContext);
  
  const OPTIONS = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
  const item = props.item;
  const index = props.index;
  const isShowAnswer = props.isShowAnswer;
  const isSubmit = props.isSubmit;
  const correct = props.correct;
  const selected = props.selected;
  const testName = props.testName;
  
  // Card animations
  const optionVariants = {
    hover: { 
      scale: 1.01,
      boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
      transition: { type: "spring", stiffness: 400, damping: 15 }
    },
    tap: { scale: 0.98 }
  };
  
  // Helper function to get icon background color
  const getIconBg = () => {
    if (testName == 'test') {
      return getPracticeTestIconBg(theme, currentTheme);
    }else{
      return getStudyIconBg(theme, currentTheme);
    }
  }

  // Helper function for text color
  const getTextColor = () => {
    return currentTheme === 'light' 
      ? theme?.text?.light
      : theme?.text?.dark;
  };
  const getColorGreen = () => {
    return theme?.color.green.main;
  }
  const getColorRed = () => {
    return theme?.color.red.main;
  }

  function getStyles() {
    let backgroundColor = currentTheme === 'light' ? theme?.homeCard?.start_light : theme?.homeCard?.start_dark
    let borderColor = currentTheme === 'light' ? theme?.homeCard?.end_light : theme?.homeCard?.end_dark
    let optionBgColor = 'transparent';
    let optionTextColor = getTextColor();
    let boxShadow = 'none';

    // Multi-select questions
    if (Array.isArray(props.correct)) {
      if (isSubmit) {
        if (correct.includes(OPTIONS[index])) {
          // Correct answer
          borderColor = getColorGreen();
          optionBgColor = getColorGreen();
          optionTextColor = '#ffffff';
          boxShadow = '0 0 0 1px ' + getColorGreen();
        } else if (selected?.includes(OPTIONS[index])) {
          // Incorrect selected answer
          borderColor = getColorRed();
          optionBgColor = getColorRed();
          optionTextColor = '#ffffff';
          boxShadow = '0 0 0 1px ' + getColorRed();
        }
      } else if (selected?.includes(OPTIONS[index])) {
        // Selected but not submitted yet
        borderColor = getIconBg();
        optionBgColor = getIconBg();
        optionTextColor = '#ffffff';
        boxShadow = '0 0 0 1px ' + getIconBg();
      }
    } else {
      // Single-select questions
      if (isShowAnswer && selected && selected !== "X") {
        if (selected === correct && OPTIONS[index] === correct) {
          // Correct answer that was selected
          borderColor = getColorGreen();
          optionBgColor = getColorGreen();
          optionTextColor = '#ffffff';
          boxShadow = '0 0 0 1px ' + getColorGreen();
        } else if (correct === OPTIONS[index]) {
          // Correct answer
          borderColor = getColorGreen();
          optionBgColor = getColorGreen();
          optionTextColor = '#ffffff';
          boxShadow = '0 0 0 1px ' + getColorGreen();
        } else if (selected === OPTIONS[index]) {
          // Incorrect selected answer
          borderColor = getColorRed();
          optionBgColor = getColorRed();
          optionTextColor = '#ffffff';
          boxShadow = '0 0 0 1px ' + getColorRed();
        }
      } else if (selected === OPTIONS[index]) {
        // Selected but answer not shown yet
        borderColor = getIconBg();
        optionBgColor = getIconBg();
        optionTextColor = '#ffffff';
        boxShadow = '0 0 0 1px ' + getIconBg();
      }
    }

    return {
      backgroundColor,
      borderColor,
      optionBgColor,
      optionTextColor,
      boxShadow
    };
  }

  function onPress() {
    if (Array.isArray(props.correct)) {
      if (!props.isSubmit) {
        props.onPress();
      }
    } else {
      if (props.isShowAnswer && (selected == "X" || selected == null)) {
        props.onPress();
      } else if (!props.isShowAnswer) {
        props.onPress();
      }
    }
  }

  const styles = getStyles();
  const isDisabled = 
    (Array.isArray(props.correct) && props.isSubmit) || 
    (props.isShowAnswer && selected !== "X" && selected !== null);

  return (
    <motion.div
      whileHover={isDisabled ? {} : "hover"}
      whileTap={isDisabled ? {} : "tap"}
      variants={optionVariants}
      className="h-full flex flex-col rounded-xl overflow-hidden shadow-sm cursor-pointer"
      onClick={() => onPress()}
      style={{
        backgroundColor: styles.backgroundColor,
        border: `1px solid ${styles.borderColor}`,
        boxShadow: styles.boxShadow
      }}
    >
      <div className="flex-1 flex items-stretch">
        {/* Option content */}
        <div className="flex-1 p-4">
          <HTMLContent index={index} htmlContent={item} />
        </div>
        
        {/* Option letter */}
        <div 
          className="flex items-center justify-center px-6"
          style={{ 
            backgroundColor: styles.optionBgColor,
            color: styles.optionTextColor,
            borderLeft: `1px solid ${styles.borderColor}`
          }}
        >
          <span className="text-xl font-medium">
            {OPTIONS[index]}
          </span>
        </div>
      </div>
    </motion.div>
  );
};

export default QuestionOptions;